import { createContext, useContext, useMemo, useState } from "react";

const DEFAULT_FILTER = {
  Page: 1,
  Limit: 25,
  SearchBy: null,
  SearchValue: "",
  To: null,
  Op: null,
};

const ChatStateContext = createContext(null);

export function ChatStateProvider({ children, initialRoom = null, initialFilter = {} }) {
  const [selectedRoom, setSelectedRoom] = useState(initialRoom);
  const [filter, setFilterState] = useState({ ...DEFAULT_FILTER, ...initialFilter });

  const setFilter = (updates = {}) => {
    setFilterState((prev) => ({ ...prev, ...updates }));
  };

  const resetChatData = () => {
    setSelectedRoom(null);
  };

  const value = useMemo(
    () => ({
      selectedRoom,
      setSelectedRoom,
      resetChatData,
      filter,
      setFilter,
    }),
    [selectedRoom, filter]
  );

  return (
    <ChatStateContext.Provider value={value}>
      {children}
    </ChatStateContext.Provider>
  );
}

export function useChatState() {
  const context = useContext(ChatStateContext);
  if (!context) {
    throw new Error("useChatState must be used within ChatStateProvider.");
  }
  return context;
}
